import { diffWordsWithSpace } from 'diff';

export const highlightDifferences = (originalText, newText, highlightType) => {
    if (!newText) return null;

    const cleanOriginal = normalizeText(originalText || '');
    const cleanNew = normalizeText(newText);

    const diff = diffWordsWithSpace(cleanOriginal, cleanNew);

    return diff.map((part, index) => {
        const isSpace = /^\s+$/.test(part.value);

        if (highlightType === 'added' && part.added) {
            return (
                <span
                    key={index}
                    className="bg-green-200"
                    style={isSpace ? { outline: '1px dashed green' } : {}}
                    title={isSpace ? 'Добавленный пробел' : undefined}
                >
                    {part.value}
                </span>
            );
        }
        if (highlightType === 'removed' && part.removed) {
            return (
                <span
                    key={index}
                    className="bg-red-200"
                    style={isSpace ? { outline: '1px dashed red' } : {}}
                    title={isSpace ? 'Удалённый пробел' : undefined}
                >
                    {part.value}
                </span>
            );
        }
        if (!part.added && !part.removed) {
            return <span key={index}>{part.value}</span>;
        }
        return null;
    });
};

function normalizeText(text) {
    return text
        .replace(/\u00A0/g, ' ')
        .replace(/\u200B/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}
